module.exports = __webpack_public_path__ + "static/mahou-MONEI-290c0fdceb1d5070bbc069f59493ce40.png";